<template>
    <div class="backdrop" style="z-index:100" @click.self="onNo">
        <div class="message-box-2">
            <div style="display:flex;justify-content:center">
                {{ messageBoxModel.caption }}
            </div>
            <div style="margin-bottom:10px">
                <hr class="header-divider" />
            </div>
            <div style="display:flex;justify-content:space-between; flex-direction: column;height:100%">
                <div style="text-align:left">
                    <div v-for="message in messageBoxModel.message" :key="message" id="message_box_v2_message">{{ message }}&nbsp;</div>
                </div>
                <div class="message-box-2-button-bar">
                    <button class="administrator-button message-box-2-button" @click="onYes" ref="btnYes" v-show="messageBoxModel.btnYes" id="message_box_v2_yes">
                        {{ messageBoxModel.btnYesText }}
                    </button>
                    <button class="administrator-button message-box-2-button" @click="onNo" ref="btnNo" v-show="messageBoxModel.btnNo" id="message_box_v2_no">
                        {{ messageBoxModel.btnNoText }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { getCurrentInstance } from "@vue/runtime-core";

export default {
    props: ["messageBoxModel"],
    setup(props, { emit }) {
        const emitter = getCurrentInstance().appContext.app.config.globalProperties.emitter;

        const btnNo = ref(null);
        const btnYes = ref(null);

        const onNo = () => {
            emitter.emit("message-box-no-" + props.messageBoxModel.callbackId);
            emit("on-close");
        };

        const onYes = () => {
            emitter.emit("message-box-" + props.messageBoxModel.callbackId);
            emit("on-close");
        };

        onMounted(() => {
            if (props.messageBoxModel.defaultYes) {
                btnYes.value.focus();
                btnNo.value.classList.add("button-cancel")
            } else {
                btnNo.value.focus();
                btnYes.value.classList.add("button-cancel")

                if (!props.messageBoxModel.btnYes) {
                    btnNo.value.classList.add("button-cancel")
                }
            }
        });

        return { btnNo, btnYes, onNo, onYes };
    }
};
</script>

<style scoped>
/* @media (orientation: landscape) { */
@media (pointer: fine), (pointer: none) {
    .message-box-2 {
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -105px;
        margin-left: -255px;
        width: 500px;
        height: 200px;
        background: var(--main-background);
        border-radius: 10px;
        padding: 10px;
        border: 1px solid var(--card-body-border);
    }
}


/* @media (orientation: portrait) { */
@media (pointer: coarse)  {    
    .message-box-2 {
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -105px;
        margin-left: -255px;
        width: 500px;
        height: 200px;
        background: var(--main-background);
        border-radius: 10px;
        padding: 10px;
        border: 1px solid var(--card-body-border);
    }
}

.message-box-2-button-bar {
    display: flex;
    justify-content: flex-end;
    padding: 5px;
    margin: 0px;
}

.message-box-2-button {
    /* background-color: cornflowerblue; */
    /* color: var(--button-color); */
    padding: 10px;
    margin-right: 10px;
    /* width: 75px;
    cursor: pointer; */
}
</style>
